import React from 'react';
import '../../css/ModalAlert.css';

const ModalAlert = ({ show, onClose, title, children }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal">
        {/* <div className="modal-header">
          <h4 className="modal-title">{title}</h4>
        </div> */}
        <div className="modal-body">
          {children}
        </div>
       {onClose && 
        <div className="modal-footer">
        <button onClick={onClose} className="modal-close-button">OK</button>
      </div>}
      </div>
    </div>
  );
};

export default ModalAlert;
